import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

function toStartOfDay(date) {
  if (!date) return null;
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function toEndOfDay(date) {
  if (!date) return null;
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function useUsers({ startDate, endDate, emailVerifiedFilter, limit = 400, isAnonymous = false }) {
  const [users, setUsers] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const db = firebase.firestore();
    let query = db.collection('users').where('isAnonymous', '==', isAnonymous);

    if (!isAnonymous && typeof emailVerifiedFilter === 'boolean') {
      query = query.where('emailVerified', '==', emailVerifiedFilter);
    }

    const normalizedStartDate = toStartOfDay(startDate);
    const normalizedEndDate = toEndOfDay(endDate);

    if (normalizedStartDate) {
      query = query.where('createdAt', '>=', firebase.firestore.Timestamp.fromDate(normalizedStartDate));
    }
    if (normalizedEndDate) {
      query = query.where('createdAt', '<=', firebase.firestore.Timestamp.fromDate(normalizedEndDate));
    }

    query = query.orderBy('createdAt', 'desc').limit(limit);

    setLoading(true);
    const unsubscribe = query.onSnapshot((snapshot) => {
      const nextUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(nextUsers);
      setLoading(false);
    }, (error) => {
      console.error('[useUsers] Failed to load users:', error);
      setUsers([]);
      setLoading(false);
    });

    return () => {
      unsubscribe();
      setLoading(false);
    };
  }, [
    startDate ? new Date(startDate).getTime() : null,
    endDate ? new Date(endDate).getTime() : null,
    emailVerifiedFilter,
    limit,
    isAnonymous,
  ]);

  return [loading, users];
}
